<template>
  <div>
    <div class="ma-2">
      <div class="text-h4 grey--text text--darken-3">Soft Lens Companies</div>
      <div class="caption ml-2">Click a company to view its lenses.</div>
    </div>
    <v-container>
      <v-row>
        <v-col>
          <div class="d-flex flex-row flex-wrap ml-3 mt-2">
            <!-- {{ $store.getters.favoriteCompanies }} -->
            <v-card
              v-for="(company, index) in favoriteCompanies"
              :key="'Y' + index"
              :width="$vuetify.breakpoint.smAndUp ? '200' : '100%'"
              height="70px"
              class="ma-2"
              depressed
              hover
              :to="link(company)"
            >
              <v-card-text
                class="text-center full-height d-flex flex-column align-center"
                style="height: 40px"
                height="50px"
              >
                <v-img
                  v-if="company && company.image"
                  :src="company.image"
                  contain
                  max-width="180"
                  height="35"
                ></v-img>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <!-- <v-divider></v-divider> -->
          <div class="d-flex flex-row flex-wrap ml-3 mt-2">
            <v-card
              v-for="(company, index) in nonFavoriteCompanies"
              :key="'Y' + index"
              :width="$vuetify.breakpoint.smAndUp ? '200' : '100%'"
              class="ma-2"
              depressed
              hover
              :to="link(company)"
            >
              <v-card-text class="text-center">
                <div style="height: 50px">
                  <v-img
                    v-if="company && company.image"
                    :src="company.image"
                    contain
                    max-width="180px"
                    max-height="35px"
                  ></v-img>
                </div>
                {{ company.name }}
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";

export default {
  name: "SelectCompany",
  mixins: [ClCompanyMixin],
  props: {
    makeLinks: { type: Boolean, default: true },
  },
  data: function () {
    return {};
  },
  methods: {
    link(companyObject) {
      if (!this.makeLinks) return null;
      return { path: "/cls/company/" + companyObject.slug };
    },
  },
  computed: {},
  metaInfo() {
    return {
      title: "EyeDock/CLs | Companies",
    };
  },
};
</script>

<style scoped></style>
